exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".control-label,.form-horizontal .control-label{text-align:left}.main-area{background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-369dd86d!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DeceasedEdit.vue
// module id = 368
// module chunks = 0